import React from 'react'
import rfidPhoto from '../../signin-workshop-industrial-20x40.png'
import logo from '../../rfidinterlock-logo.png'
import './Account.css'

const LoginScaffold: React.FC<React.PropsWithChildren> = ({children}) => {
  return (
    <div className="Login-container">
      <div className="Login-rfid-photo-container" aria-hidden="true">
        <img src={rfidPhoto} className="Login-rfid-photo" alt="" />
      </div>
      <div className="Login-form-container">
        <div className="Login-panel">
          <img src={logo} className="Login-logo" alt="RFID Interlock"/>
          {children}
        </div>
      </div>
    </div>
  );
}

export default LoginScaffold;
